// import React, { useEffect, useState } from "react";
// import { Api } from "../Api/Api";

// const API_BASE = `${Api}company`;

// export default function CompanyDetails() {
//   const [companies, setCompanies] = useState([]);
//   const [loading, setLoading] = useState(false);
//   const [message, setMessage] = useState(null);

//   const [editId, setEditId] = useState(null);
//   const [formData, setFormData] = useState({
//     companyName: "",
//     gstNumber: "",
//     ownerName: "",
//     address: "",
//     contactNumber: "",
//   });

//   const fetchCompanies = async () => {
//     setLoading(true);
//     setMessage(null);
//     try {
//       const res = await fetch(`${API_BASE}/get.php`);
//       if (!res.ok) throw new Error("Failed to fetch");
//       const data = await res.json();
//       setCompanies(data);
//     } catch (err) {
//       setMessage("Failed to load company details.");
//       console.error(err);
//     }
//     setLoading(false);
//   };

//   useEffect(() => {
//     fetchCompanies();
//   }, []);

//   const handleChange = (e) => {
//     setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
//   };

//   const handleEditClick = (company) => {
//     setEditId(company.id);
//     setFormData({
//       companyName: company.company_name,
//       gstNumber: company.gst_number,
//       ownerName: company.owner_name,
//       address: company.address,
//       contactNumber: company.contact_number,
//     });
//     setMessage(null);
//   };

//   const cancelEdit = () => {
//     setEditId(null);
//     setFormData({
//       companyName: "",
//       gstNumber: "",
//       ownerName: "",
//       address: "",
//       contactNumber: "",
//     });
//     setMessage(null);
//   };

//   const handleUpdate = async (e) => {
//     e.preventDefault();
//     if (!editId) return;

//     setLoading(true);
//     setMessage(null);

//     try {
//       const res = await fetch(`${API_BASE}/update.php`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ id: editId, ...formData }),
//       });
//       const data = await res.json();
//       if (!res.ok) throw new Error(data.message || "Update failed");

//       setMessage(data.message);
//       setEditId(null);
//       setFormData({
//         companyName: "",
//         gstNumber: "",
//         ownerName: "",
//         address: "",
//         contactNumber: "",
//       });
//       fetchCompanies();
//     } catch (err) {
//       setMessage(err.message || "Failed to update company.");
//       console.error(err);
//     }

//     setLoading(false);
//   };

//   const handleDelete = async (id) => {
//     if (!window.confirm("Are you sure you want to delete this company?"))
//       return;

//     setLoading(true);
//     setMessage(null);

//     try {
//       const res = await fetch(`${API_BASE}/delete.php`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ id }),
//       });
//       const data = await res.json();
//       if (!res.ok) throw new Error(data.message || "Delete failed");

//       setMessage(data.message);
//       fetchCompanies();
//     } catch (err) {
//       setMessage(err.message || "Failed to delete company.");
//       console.error(err);
//     }

//     setLoading(false);
//   };

//   return (
//     <div className="max-w-5xl mx-auto p-4 sm:p-6 bg-white shadow rounded mt-10">
//       <h2 className="text-2xl font-semibold mb-6 text-center">
//         Company Details
//       </h2>

//       {message && (
//         <div
//           className={`mb-4 p-3 rounded ${
//             message.toLowerCase().includes("success")
//               ? "bg-green-100 text-green-700"
//               : "bg-red-100 text-red-700"
//           }`}
//         >
//           {message}
//         </div>
//       )}

//       {loading && (
//         <div className="mb-4 text-center text-gray-600">Loading...</div>
//       )}

//       {editId && (
//         <form
//           onSubmit={handleUpdate}
//           className="mb-8 space-y-4 border p-4 rounded bg-gray-50"
//         >
//           <h3 className="text-xl font-semibold mb-4 text-center">
//             Edit Company ID: {editId}
//           </h3>

//           <div>
//             <label className="block mb-1 font-medium" htmlFor="companyName">
//               Company Name
//             </label>
//             <input
//               type="text"
//               id="companyName"
//               name="companyName"
//               required
//               className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
//               value={formData.companyName}
//               onChange={handleChange}
//               placeholder="Enter company name"
//             />
//           </div>

//           <div>
//             <label className="block mb-1 font-medium" htmlFor="gstNumber">
//               GST Number
//             </label>
//             <input
//               type="text"
//               id="gstNumber"
//               name="gstNumber"
//               required
//               className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
//               value={formData.gstNumber}
//               onChange={handleChange}
//               placeholder="Enter GST number"
//             />
//           </div>

//           <div>
//             <label className="block mb-1 font-medium" htmlFor="ownerName">
//               Owner Name
//             </label>
//             <input
//               type="text"
//               id="ownerName"
//               name="ownerName"
//               required
//               className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
//               value={formData.ownerName}
//               onChange={handleChange}
//               placeholder="Enter owner name"
//             />
//           </div>

//           <div>
//             <label className="block mb-1 font-medium" htmlFor="address">
//               Address
//             </label>
//             <textarea
//               id="address"
//               name="address"
//               required
//               rows={3}
//               className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
//               value={formData.address}
//               onChange={handleChange}
//               placeholder="Enter address"
//             />
//           </div>

//           <div>
//             <label className="block mb-1 font-medium" htmlFor="contactNumber">
//               Contact Number
//             </label>
//             <input
//               type="tel"
//               id="contactNumber"
//               name="contactNumber"
//               required
//               pattern="[0-9]{10}"
//               className="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-indigo-500"
//               value={formData.contactNumber}
//               onChange={handleChange}
//               placeholder="Enter 10-digit contact number"
//             />
//           </div>

//           <div className="flex gap-3">
//             <button
//               type="submit"
//               disabled={loading}
//               className="flex-1 bg-indigo-600 text-white py-2 rounded hover:bg-indigo-700 transition"
//             >
//               {loading ? "Saving..." : "Update"}
//             </button>
//             <button
//               type="button"
//               onClick={cancelEdit}
//               className="flex-1 bg-gray-400 text-black py-2 rounded hover:bg-gray-500 transition"
//             >
//               Cancel
//             </button>
//           </div>
//         </form>
//       )}

//       {/* Responsive table wrapper */}
//       {/* <div className="overflow-x-auto">
//         <table className="w-full table-auto border-collapse border border-gray-300 min-w-[700px]"> */}
//       <div className="w-full overflow-x-auto">
//         <table className="min-w-[900px] border-collapse border border-gray-300">
//           <thead>
//             <tr className="bg-gray-100">
//               <th className="border border-gray-300 px-4 py-2 text-left whitespace-nowrap">
//                 ID
//               </th>
//               <th className="border border-gray-300 px-4 py-2 text-left whitespace-nowrap">
//                 Company Name
//               </th>
//               <th className="border border-gray-300 px-4 py-2 text-left whitespace-nowrap">
//                 GST Number
//               </th>
//               <th className="border border-gray-300 px-4 py-2 text-left whitespace-nowrap">
//                 Owner Name
//               </th>
//               <th className="border border-gray-300 px-4 py-2 text-left whitespace-nowrap">
//                 Email
//               </th>
//               <th className="border border-gray-300 px-4 py-2 text-left whitespace-nowrap">
//                 Address
//               </th>
//               <th className="border border-gray-300 px-4 py-2 text-left whitespace-nowrap">
//                 Contact Number
//               </th>
//               <th className="border border-gray-300 px-4 py-2 text-center whitespace-nowrap">
//                 Actions
//               </th>
//             </tr>
//           </thead>
//           {/* <tbody>
//             {companies.length === 0 && (
//               <tr>
//                 <td colSpan="7" className="text-center py-6 text-gray-500">
//                   No companies found.
//                 </td>
//               </tr>
//             )}
//             {companies.map((company) => (
//               <tr key={company.id} className="hover:bg-gray-50">
//                 <td className="border border-gray-300 px-4 py-2">
//                   {company.id}
//                 </td>
//                 <td className="border border-gray-300 px-4 py-2">
//                   {company.company_name}
//                 </td>
//                 <td className="border border-gray-300 px-4 py-2">
//                   {company.gst_number}
//                 </td>
//                 <td className="border border-gray-300 px-4 py-2">
//                   {company.owner_name}
//                 </td>
//                 <td className="border border-gray-300 px-4 py-2">
//                   {company.email}
//                 </td>
//                 <td className="border border-gray-300 px-4 py-2">
//                   {company.address}
//                 </td>
//                 <td className="border border-gray-300 px-4 py-2">
//                   {company.contact_number}
//                 </td>

//                 <td className="border border-gray-300 px-4 py-2 text-center">
//                   <div className="flex justify-center gap-2">
//                     <button
//                       onClick={() => handleEditClick(company)}
//                       className="px-3 py-1 bg-yellow-400 rounded hover:bg-yellow-500 text-black"
//                     >
//                       Edit
//                     </button>
//                     <button
//                       onClick={() => handleDelete(company.id)}
//                       className="px-3 py-1 bg-red-500 rounded hover:bg-red-600 text-white"
//                     >
//                       Delete
//                     </button>
//                   </div>
//                 </td>
//               </tr>
//             ))}
//           </tbody> */}
//           <tbody>
//             {companies.length === 0 && (
//               <tr>
//                 <td colSpan="8" className="text-center py-6 text-gray-500">
//                   No companies found.
//                 </td>
//               </tr>
//             )}
//             {companies.map((company, index) => (
//               <tr key={company.id} className="hover:bg-gray-50">
//                 {/* Serial number */}
//                 <td className="border border-gray-300 px-4 py-2">
//                   {index + 1}
//                 </td>

//                 <td className="border border-gray-300 px-4 py-2">
//                   {company.company_name}
//                 </td>
//                 <td className="border border-gray-300 px-4 py-2">
//                   {company.gst_number}
//                 </td>
//                 <td className="border border-gray-300 px-4 py-2">
//                   {company.owner_name}
//                 </td>
//                 <td className="border border-gray-300 px-4 py-2">
//                   {company.email}
//                 </td>
//                 <td className="border border-gray-300 px-4 py-2">
//                   {company.address}
//                 </td>
//                 <td className="border border-gray-300 px-4 py-2">
//                   {company.contact_number}
//                 </td>

//                 <td className="border border-gray-300 px-4 py-2 text-center">
//                   <div className="flex justify-center gap-2">
//                     <button
//                       onClick={() => handleEditClick(company)}
//                       className="px-3 py-1 bg-yellow-400 rounded hover:bg-yellow-500 text-black"
//                     >
//                       Edit
//                     </button>
//                     <button
//                       onClick={() => handleDelete(company.id)}
//                       className="px-3 py-1 bg-red-500 rounded hover:bg-red-600 text-white"
//                     >
//                       Delete
//                     </button>
//                   </div>
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>
//       </div>
//     </div>
//   );
// }

import React, { useEffect, useState } from "react";
import { Api } from "../Api/Api";
import Swal from "sweetalert2"; // ✅ Import swal

const API_BASE = `${Api}company`;

export default function CompanyDetails() {
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  const [editId, setEditId] = useState(null);
  const [formData, setFormData] = useState({
    companyName: "",
    gstNumber: "",
    ownerName: "",
    address: "",
    contactNumber: "",
  });

  const fetchCompanies = async () => {
    setLoading(true);
    setMessage(null);
    try {
      const res = await fetch(`${API_BASE}/get.php`);
      if (!res.ok) throw new Error("Failed to fetch");
      const data = await res.json();
      setCompanies(data);
    } catch (err) {
      setMessage("❌ Failed to load company details.");
      console.error(err);
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchCompanies();
  }, []);

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleEditClick = (company) => {
    setEditId(company.id);
    setFormData({
      companyName: company.company_name,
      gstNumber: company.gst_number,
      ownerName: company.owner_name,
      address: company.address,
      contactNumber: company.contact_number,
    });
    setMessage(null);
  };

  const cancelEdit = () => {
    setEditId(null);
    setFormData({
      companyName: "",
      gstNumber: "",
      ownerName: "",
      address: "",
      contactNumber: "",
    });
    setMessage(null);
  };

  // 🔹 Update with swal
  const handleUpdate = async (e) => {
    e.preventDefault();
    if (!editId) return;

    Swal.fire({
      title: "Update Confirmation",
      text: "Are you sure you want to update this company?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, update it!",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (!result.isConfirmed) return;

      setLoading(true);
      setMessage(null);

      try {
        const res = await fetch(`${API_BASE}/update.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: editId, ...formData }),
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.message || "Update failed");

        Swal.fire("Updated!", "Company updated successfully.", "success");
        setEditId(null);
        cancelEdit();
        fetchCompanies();
      } catch (err) {
        console.error(err);
        Swal.fire("Error", err.message || "Failed to update company.", "error");
      }

      setLoading(false);
    });
  };

  // 🔹 Delete with swal
  const handleDelete = async (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "This company will be permanently deleted!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (!result.isConfirmed) return;

      setLoading(true);
      setMessage(null);

      try {
        const res = await fetch(`${API_BASE}/delete.php`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id }),
        });
        const data = await res.json();
        if (!res.ok) throw new Error(data.message || "Delete failed");

        Swal.fire("Deleted!", "Company deleted successfully.", "success");
        fetchCompanies();
      } catch (err) {
        console.error(err);
        Swal.fire("Error", err.message || "Failed to delete company.", "error");
      }

      setLoading(false);
    });
  };

  return (
    <div className="max-w-5xl mx-auto p-4 sm:p-6 bg-white shadow rounded mt-10">
      <h2 className="text-2xl font-semibold mb-6 text-center">
        Company Details
      </h2>

      {message && (
        <div
          className={`mb-4 p-3 rounded text-center ${
            message.includes("✅")
              ? "bg-green-100 text-green-700"
              : "bg-red-100 text-red-700"
          }`}
        >
          {message}
        </div>
      )}

      {loading && (
        <div className="mb-4 text-center text-gray-600">Loading...</div>
      )}

      {/* Edit Form */}
      {editId && (
        <form
          onSubmit={handleUpdate}
          className="mb-8 space-y-4 border p-4 rounded bg-gray-50"
        >
          <h3 className="text-xl font-semibold mb-4 text-center">
            Edit Company ID: {editId}
          </h3>

          {[
            "companyName",
            "gstNumber",
            "ownerName",
            "address",
            "contactNumber",
          ].map((field) => (
            <div key={field}>
              <label className="block mb-1 font-medium" htmlFor={field}>
                {field.replace(/([A-Z])/g, " $1")}
              </label>
              {field === "address" ? (
                <textarea
                  id={field}
                  name={field}
                  rows={3}
                  required
                  value={formData[field]}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded px-3 py-2 focus:ring-2 focus:ring-indigo-500"
                />
              ) : (
                <input
                  type={field === "contactNumber" ? "tel" : "text"}
                  id={field}
                  name={field}
                  required
                  pattern={field === "contactNumber" ? "[0-9]{10}" : undefined}
                  value={formData[field]}
                  onChange={handleChange}
                  className="w-full border border-gray-300 rounded px-3 py-2 focus:ring-2 focus:ring-indigo-500"
                />
              )}
            </div>
          ))}

          <div className="flex gap-3">
            <button
              type="submit"
              disabled={loading}
              className="flex-1 bg-indigo-600 text-white py-2 rounded hover:bg-indigo-700 transition"
            >
              {loading ? "Saving..." : "Update"}
            </button>
            <button
              type="button"
              onClick={cancelEdit}
              className="flex-1 bg-gray-400 text-black py-2 rounded hover:bg-gray-500 transition"
            >
              Cancel
            </button>
          </div>
        </form>
      )}

      {/* Table */}
      <div className="w-full overflow-x-auto">
        <table className="min-w-[900px] border-collapse border border-gray-300">
          <thead>
            <tr className="bg-gray-100">
              {[
                "ID",
                "Company Name",
                "GST Number",
                "Owner Name",
                "Email",
                "Address",
                "Contact Number",
                "Actions",
              ].map((col) => (
                <th
                  key={col}
                  className="border border-gray-300 px-4 py-2 text-left whitespace-nowrap"
                >
                  {col}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {companies.length === 0 ? (
              <tr>
                <td colSpan="8" className="text-center py-6 text-gray-500">
                  No companies found.
                </td>
              </tr>
            ) : (
              companies.map((company, index) => (
                <tr key={company.id} className="hover:bg-gray-50">
                  <td className="border border-gray-300 px-4 py-2">
                    {index + 1}
                  </td>
                  <td className="border border-gray-300 px-4 py-2">
                    {company.company_name}
                  </td>
                  <td className="border border-gray-300 px-4 py-2">
                    {company.gst_number}
                  </td>
                  <td className="border border-gray-300 px-4 py-2">
                    {company.owner_name}
                  </td>
                  <td className="border border-gray-300 px-4 py-2">
                    {company.email}
                  </td>
                  <td className="border border-gray-300 px-4 py-2">
                    {company.address}
                  </td>
                  <td className="border border-gray-300 px-4 py-2">
                    {company.contact_number}
                  </td>
                  <td className="border border-gray-300 px-4 py-2 text-center">
                    <div className="flex justify-center gap-2">
                      <button
                        onClick={() => handleEditClick(company)}
                        className="px-3 py-1 bg-yellow-400 rounded hover:bg-yellow-500 text-black"
                      >
                        Edit
                      </button>
                      <button
                        onClick={() => handleDelete(company.id)}
                        className="px-3 py-1 bg-red-500 rounded hover:bg-red-600 text-white"
                      >
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
